import { z } from 'my-zod'

const successActionSchema = z.object({
  status: z.enum(['succeeded', 'in_progress']),
  failure_code: z.null(),
  failure_message: z.null()
})

const failedActionSchema = z.object({
  status: z.literal('failed'),
  failure_code: z.string(),
  failure_message: z.string()
})

const processPaymentIntentSchema = z.object({
  type: z.literal('process_payment_intent'),
  process_payment_intent: z.object({
    payment_intent: z.string()
  })
})

const processSetupIntentSchema = z.object({
  type: z.literal('process_setup_intent')
})

const refundPaymentSchema = z.object({
  type: z.literal('refund_payment')
})

const setReaderDisplaySchema = z.object({
  type: z.literal('set_reader_display')
})

const processPaymentIntentAction = z.union([
  successActionSchema.merge(processPaymentIntentSchema),
  failedActionSchema.merge(processPaymentIntentSchema)
])

const processSetupIntentAction = z.union([
  successActionSchema.merge(processSetupIntentSchema),
  failedActionSchema.merge(processSetupIntentSchema)
])

const refundPaymentAction = z.union([
  successActionSchema.merge(refundPaymentSchema),
  failedActionSchema.merge(refundPaymentSchema)
])

const setReaderDisplayAction = z.union([
  successActionSchema.merge(setReaderDisplaySchema),
  failedActionSchema.merge(setReaderDisplaySchema)
])

const action = z.union([processPaymentIntentAction, processSetupIntentAction, refundPaymentAction, setReaderDisplayAction])

export const terminalModel = z.object({
  id: z.string(),
  object: z.string(),
  action: action.nullable(),
  deviceSwVersion: z.string(),
  deviceType: z.string(),
  ipAddress: z.string().nullable(),
  label: z.string(),
  lastSeenAt: z.number().optional(),
  livemode: z.boolean(),
  location: z.string(),
  metadata: z.object({}),
  serialNumber: z.string(),
  status: z.enum(['offline', 'online']).nullable()
})

export type terminalModel = z.infer<typeof terminalModel>
